// src/App.tsx
import React, { useEffect, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from "./routes";
import { useAuthStore } from "./store/auth-store";
import { Toaster } from 'sonner';
import { OfflineNotifier } from "./components/layout/OfflineNotifier";
import PageLoader from "./components/layout/PageLoader";
import GlobalModal from "./components/layout/GlobalModal";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import { AnimatePresence } from "framer-motion";
import { useIdle } from "./hooks/useIdle";
import Screensaver from "./components/layout/Screensaver";

import "./App.css";
import 'shepherd.js/dist/css/shepherd.css';
import './tour/tour.css';

function App() {
  const { checkAuthStatus } = useAuthStore();
  // Set to 3 seconds for easy testing. Change to 30000 for 5 minutes in production.
  const { isIdle, setIsIdle } = useIdle({ timeout: 300000 });

  useEffect(() => {
    checkAuthStatus();
  }, [checkAuthStatus]);

  return (
    <Router>
      <Suspense fallback={<PageLoader fullPage />}>
        <AppRoutes />
      </Suspense>
      <Toaster richColors theme="dark" />
      <SpeedInsights/>
      <Analytics />
      <OfflineNotifier />
      <GlobalModal />

      <AnimatePresence>
        {isIdle && <Screensaver onDismiss={() => setIsIdle(false)} />}
      </AnimatePresence>
    </Router>
  );
}

export default React.memo(App);